import { createAction, props } from '@ngrx/store';
import { EqualizerPreset, EqualizerBand } from './objects/media-player/equalizer-preset';

export const initializeEqualizer = createAction(
  '[Equalizer] Initialize'
);

export const loadPresetsFromStorage = createAction(
  '[Equalizer] Load Presets From Storage'
);

export const loadPresetsFromStorageSuccess = createAction(
  '[Equalizer] Load Presets From Storage Success',
  props<{ presets: EqualizerPreset[] }>()
);

export const selectPreset = createAction(
  '[Equalizer] Select Preset',
  props<{ preset: EqualizerPreset }>()
);

export const updateBand = createAction(
  '[Equalizer] Update Band',
  props<{ bandIndex: number; gain: number }>()
);

export const enableEqualizer = createAction(
  '[Equalizer] Enable'
);

export const disableEqualizer = createAction(
  '[Equalizer] Disable'
);

export const createCustomPreset = createAction(
  '[Equalizer] Create Custom Preset',
  props<{ name: string; bands: EqualizerBand[] }>()
);

export const deleteCustomPreset = createAction(
  '[Equalizer] Delete Custom Preset',
  props<{ presetId: string }>()
);

export const updateCustomPreset = createAction(
  '[Equalizer] Update Custom Preset',
  props<{ presetId: string; name?: string; bands?: EqualizerBand[] }>()
);

export const savePresetsToStorage = createAction(
  '[Equalizer] Save Presets To Storage',
  props<{ presets: EqualizerPreset[] }>()
);

export const restoreEqualizerSettings = createAction(
  '[Equalizer] Restore Settings',
  props<{ presetId: string; bands: EqualizerBand[]; isEnabled: boolean }>()
);
